<div class="reset-password-page">
    <div class="reset-password-container">
        <div class="reset-password-card">
            <!-- Logo Section -->
            <div class="logo-header">
                <img src="assets/images/lens-blueprint-logo.svg" alt="Lens Blueprint" class="brand-logo"
                    onerror="this.style.display='none'" />
                <h1 class="brand-title">Lens Blueprint</h1>
                <p class="brand-subtitle">Assessment Dashboard</p>
            </div>

            <!-- Form Section -->
            <div class="form-section" *ngIf="!showSuccessMessage">
                <h2 class="form-title">Reset Your Password</h2>
                <p class="form-description">Enter your new password below.</p>

                <form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()" class="reset-password-form">
                    <!-- Error Message -->
                    <div class="error-alert" *ngIf="error">
                        <mat-icon>error_outline</mat-icon>
                        <span>{{ error }}</span>
                    </div>

                    <!-- Password Field -->
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-label>New Password</mat-label>
                        <input
                            matInput
                            formControlName="password"
                            [type]="hidePassword ? 'password' : 'text'"
                            placeholder="Enter your new password"
                        />
                        <button
                            mat-icon-button
                            matSuffix
                            (click)="hidePassword = !hidePassword"
                            [attr.aria-label]="'Hide password'"
                            [attr.aria-pressed]="hidePassword"
                            type="button"
                        >
                            <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                        </button>
                        <mat-error *ngIf="resetPasswordForm.get('password')?.hasError('required')">
                            Password is required
                        </mat-error>
                        <mat-error *ngIf="resetPasswordForm.get('password')?.hasError('minlength')">
                            Password must be at least 8 characters
                        </mat-error>
                        <mat-error *ngIf="resetPasswordForm.get('password')?.hasError('maxlength')">
                            Password must be no more than 128 characters
                        </mat-error>
                        <mat-error *ngIf="resetPasswordForm.get('password')?.hasError('complexity')">
                            Password must contain uppercase, number, and special character
                        </mat-error>
                    </mat-form-field>

                    <!-- Confirm Password Field -->
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-label>Confirm Password</mat-label>
                        <input
                            matInput
                            formControlName="confirmPassword"
                            [type]="hideConfirmPassword ? 'password' : 'text'"
                            placeholder="Confirm your new password"
                        />
                        <button
                            mat-icon-button
                            matSuffix
                            (click)="hideConfirmPassword = !hideConfirmPassword"
                            [attr.aria-label]="'Hide password'"
                            [attr.aria-pressed]="hideConfirmPassword"
                            type="button"
                        >
                            <mat-icon>{{ hideConfirmPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                        </button>
                        <mat-error *ngIf="resetPasswordForm.get('confirmPassword')?.hasError('required')">
                            Please confirm your password
                        </mat-error>
                        <mat-error *ngIf="resetPasswordForm.get('confirmPassword')?.hasError('mismatch')">
                            Passwords do not match
                        </mat-error>
                    </mat-form-field>

                    <!-- Submit Button -->
                    <button
                        mat-raised-button
                        type="submit"
                        [disabled]="!resetPasswordForm.valid || loading || !token"
                        class="submit-btn"
                    >
                        <mat-spinner diameter="20" *ngIf="loading"></mat-spinner>
                        <mat-icon *ngIf="!loading">lock_reset</mat-icon>
                        <span *ngIf="!loading">Reset Password</span>
                    </button>
                </form>
            </div>

            <!-- Success Message Section -->
            <div class="success-section" *ngIf="showSuccessMessage">
                <div class="success-icon">
                    <mat-icon>check_circle</mat-icon>
                </div>
                <h2 class="form-title">Password Reset Successful!</h2>
                <p class="form-description">
                    Your password has been successfully reset. You can now sign in with your new password.
                </p>
                <button mat-raised-button class="submit-btn" (click)="goToLogin()">
                    <mat-icon>login</mat-icon>
                    <span>Go to Sign In</span>
                </button>
            </div>

            <!-- Footer -->
            <div class="reset-password-footer">
                <p class="footer-text">
                    Remember your password?
                    <a routerLink="/login" class="footer-link">Sign in here</a>
                </p>
                <p class="copyright">&copy; {{ currentYear }} Lens Blueprint. All rights reserved.</p>
            </div>
        </div>
    </div>
</div>
